<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">
        <div class="login-panel panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Авторизация</h3>
          </div>
          <div class="panel-body">
            <p class="panel-body__text">
              Пожалуйста, выберите способ подтверждения личности
            </p>
            <div class="panel-body__buttons">
              <button class="btn btn-primary" @click="setType('password')">
                <i class="fa fa-key"></i>
                Пароль
              </button>
              <button class="btn btn-primary" @click="setType('biometrics')">
                <i class="fa fa-user"></i>
                Биометрия
              </button>
            </div>
            <div class="panel-body__button_return">
              <button
                type="button"
                class="btn btn-danger"
                @click="returnToLoginForm"
              >
                Вернуться обратно
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    setType(type) {
      this.$emit("on-type-select", type);
    },
    returnToLoginForm() {
      this.$emit("on-cancel");
    },
  },
};
</script>

<style scoped>
.panel-body__buttons {
  display: flex;
  justify-content: center;
  margin: 2.5em 0;
  column-gap: 1.5em;
}
.panel-body__button_return {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/authorization/components/VerificationTypeForm.vue